<template>
  <div class="edit_main">
    <Form
      class="fx_1"
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="120"
      inline
    >
      <FormItem label="模板名称" prop="TemplateName">
        <Input class="w-250" v-model="editModel.TemplateName"></Input>
      </FormItem>

      <FormItem label="产品代码" prop="ProductCode">
        <Select class="w-250" v-model="editModel.ProductCode" clearable>
          <Option
            v-for="(item, index) in ProductCodeSelect"
            :value="item.dictionaryValue"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="图片数量" prop="ImageNum">
        <Input type="number" class="w-250" v-model="editModel.ImageNum"></Input>
      </FormItem>

      <FormItem label="检查类型">
        <Select class="w-250" v-model="editModel.ExamType" clearable multiple>
          <Option
            v-for="(item, index) in ExamTypeSelect"
            :value="item.dictionaryValue"
            :key="index"
            >{{ item.dictionaryValue }}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="状态">
        <RadioGroup v-model="editModel.ISActived">
          <Radio label="1">启用</Radio>
          <Radio label="0">禁用</Radio>
        </RadioGroup>
      </FormItem>

        <FormItem label="所属机构" prop="OrganName">
          <Button type="primary" @click="treeModel = true">选择所属机构</Button>
          <span class="ml-5">{{ editModel.OrganName }}</span>
          <Input v-show="false" v-model="editModel.OrganName"></Input>
        </FormItem>

        <FormItem label="模板文件" prop="TemplateFileName">
          <Upload
            :format="['frx']"
            :action="uploadUrl"
            :on-format-error="handleFormatError"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :default-file-list="fileList"
          >
            <Button icon="ios-cloud-upload-outline">选择文件</Button>
            <span style="margin-left: 10px; color: red"
              >最多一个文件，文件类型：frx</span
            >
          </Upload>
        </FormItem>
    </Form>

    <Divider></Divider>

    <div class="edit_btn_group">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>

    <Modal v-model="treeModel" title="选择上级机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../organ/organTree.vue";

export default {
  components: { organTree },
  data: function () {
    const validateNum = (rule, value, callback) => {
      if (!/(^[0-9]\d*$)/.test(value)) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    };

    return {
      uploadUrl: "",
      organTypeSelect: [],
      treeModel: false,
      editModel: {
        TemplateID: "",
        TemplateName: null,
        ImageNum: 0,
        ExamType: null,
        OrganName: null,
        ISActived: "1",
        OrganID: null,
        ProductCode: null,
        TemplateFileName: null,
        TemplateFileUrl: null,
      },
      fileList: [],
      ruleValidate: {
        TemplateName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        ProductCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        OrganName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        TemplateFileName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        ImageNum: [{ validator: validateNum, trigger: "blur" }],
      },
      ProductCodeSelect: [],
      ExamTypeSelect: [],
    };
  },
  activated: function () {
    this.uploadUrl =
      localStorage.getItem("baseURL") + "/MediaCenter/PostFile";

    this.$common.getDictionaryByCode("CP00").then((data) => {
      this.ProductCodeSelect = data;
    });
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      this.ExamTypeSelect = data;
    });

    this.initData();
  },

  methods: {
    setFirstUpper(obj){
      // const keyList=Object.keys(obj)
      for(let item in obj){
        obj[item.slice(0,1).toUpperCase()+item.slice(1)]=obj[item]
        delete obj[item]
      }
    },
    initData() {
      this.$api.get("/printtemplate/getById", {id:this.$route.query.id}).then((rsp) => {
        if (rsp != false) {
          this.setFirstUpper(rsp.data)
          this.editModel=rsp.data
          if (this.editModel.ExamType) this.editModel.ExamType = this.editModel.ExamType.split(",");
          this.fileList = [{
            name: this.editModel.TemplateFileName,
            url: this.editModel.TemplateFileUrl,
          }]
        }
      });
      // let queryData = JSON.parse(this.$route.query.data);
      // for (let index_1 in this.editModel) {
      //   for (let index_2 in queryData) {
      //     if (index_1.toLocaleLowerCase() == index_2.toLocaleLowerCase()) {
      //       this.editModel[index_1] = queryData[index_2];
      //     }
      //   }
      // }
      // if (this.editModel.ExamType)
      //   this.editModel.ExamType = this.editModel.ExamType.split(",");
      // this.fileList = [
      //   {
      //     name: this.editModel.TemplateFileName,
      //     url: this.editModel.TemplateFileUrl,
      //   },
      // ];
    },

    returnBack: function () {
      this.initData()
      this.$router.push("printTemplate");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (this.editModel.ExamType) this.editModel.ExamType = this.editModel.ExamType.join();
          if (this.editModel.ProductCode == "RIS" && !this.editModel.ExamType) {
            this.$Message.error("请选择检查类型");
            return false;
          }
          if (this.editModel.ProductCode != "RIS" && !this.editModel.ImageNum) {
            this.$Message.error("请输入图片数量");
            return false;
          }
          this.$api.post("printTemplate/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
            }
          });
        }
      });
    },

    selectTreeData: function (data) {
      this.editModel.OrganID = data[0].organID;
      this.editModel.OrganName = data[0].title;
    },

    handleSuccess: function (res, file) {
      this.editModel.TemplateFileName = res.data.fileNames;
      this.editModel.TemplateFileUrl = res.data.fileUrls;
    },

    handleFormatError: function (file) {
      this.$Message.error("文件类型不正确");
    },

    handleBeforeUpload: function () {
      if (this.editModel.TemplateFileName) {
        this.$Message.error("最多上传一个文件");
        return false;
      }
    },

    handleError: function () {
      this.$Message.error("文件上传失败");
    },

    handleRemove: function (file, fileList) {
      this.editModel.TemplateFileName = null;
      this.editModel.TemplateFileUrl = null;
    },
  },
};
</script>
<style scoped>
</style>